declare namespace $ {

	type $mol_textarea__value_shm_hitalama_map_widget_float_ai_request_component_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_ai_request_component['text'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_labeler__title_shm_hitalama_map_widget_float_ai_request_component_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_map_widget_float_ai_request_component_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_labeler__Content_shm_hitalama_map_widget_float_ai_request_component_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_ai_request_component['App'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	export class $shm_hitalama_map_widget_float_ai_request_component extends $shm_hitalama_map_widget_float_ai_request_form {
		App( ): $mol_textarea
		App_label( ): $mol_labeler
		sub( ): readonly(any)[]
		create_md( id: any): any
		create_view( id: any): any
		parse_css_selectors( id: any): any
		create_classes( id: any): any
		next_request_type( ): string
	}
	
}

//# sourceMappingURL=component.view.tree.d.ts.map